<template>
  <div v-if="author && 'uupfid' in author" class="last-update">
    <div class="avatar-wrapper">
      <img v-if="'foto_url' in social_data && social_data['foto_url'] !== null" v-bind:src="`${social_data['foto_url']}?w=32&q=100`" class="circle avatar">
      <i v-else class="material-icons no-photo">person</i>
    </div>
    <div class="info-wrapper">
      <p class="name">{{ ('nome' in social_data ? social_data['nome'] : 'Carregando...') }}</p>
      <p class="date-time">{{ getDataHoraAuthor() }}</p>
    </div>
  </div>
</template>
<script>
import { converteDataHora, converteTimestamp } from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'

import SocialService from '@/services/social-service.js'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)


export default {
  name: 'LastUpdate',
  props: {
    author: Object
  },
  data (){
    return {
      social_data: {},
      author_set: (this.author ? true : false)
    }
  },
  watch: {
    author: function(opt) {
      if(this.author && 'uupfid' in this.author){
        this.loadSocialData(this.author['uupfid'])
      }
    }
  },
  methods: {
    loadSocialData (uupfid) {
      socialService.exchange([uupfid], ['nome', 'foto_url'])
      .then((social_data) => {
        this.social_data = social_data[uupfid]
      }).catch((error) => {
        console.log("Não foi possível carregar os dados da SocialAPI")
      })
    },
    getDataHoraAuthor() {
      if(this.author){
        if('timestamp' in this.author){
          return converteTimestamp(this.author['timestamp'])
        }

        if('data_hora' in this.author){
          return converteDataHora(this.author['data_hora'])
        }
      }
      return 'Carregando...'
    }
  },
  mounted(){
    if(this.author && 'uupfid' in this.author){
      this.loadSocialData(this.author['uupfid'])
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/utils/LastUpdate.vue